export default __webpack_public_path__ + "static/Medicare-redesign-d81fa572bb446e469fd8c8165859d4bf.png";